import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface UpdateStudentCostumeSizingParams {
  recitalId: string;
  performanceId: string;
  studentId: string;
  sizes?: {
    shirtSize?: string;
    dressSize?: string;
    shoeSize?: string;
    pantSize?: string;
    custom?: Record<string, string>;
  };
  notes?: string;
}

export const updateStudentCostumeSizingAPI = async ({
  recitalId,
  performanceId,
  studentId,
  ...params
}: UpdateStudentCostumeSizingParams) => {
  const response = await baseAPI.patch(
    `/recitals/${recitalId}/sizing/${studentId}?performanceId=${performanceId}`,
    params,
  );
  return response.data;
};

export const useUpdateStudentCostumeSizingMutation = () => {
  return useMutation({
    mutationFn: async (params: UpdateStudentCostumeSizingParams) => {
      return await updateStudentCostumeSizingAPI(params);
    },
    onSuccess: (_data, variables) => {
      // Invalidate the costume sizing query to refresh the data
      void queryClient.invalidateQueries({
        queryKey: [KEYS.RECITALS, variables.recitalId, KEYS.SIZING],
      });
      void queryClient.invalidateQueries({
        queryKey: [
          KEYS.RECITALS,
          variables.recitalId,
          KEYS.SIZING,
          variables.performanceId,
        ],
      });
    },
    onError: (error, variables) => {
      console.error(
        `Mutation failed for student ${variables.studentId}:`,
        error,
      );
    },
  });
};
